export function getButtonShape(props) {
  return props.circular ? 'circle' : 'rectangle'
}

export function shouldRenderFacebookIcon(props) {
  return props.type === 'Facebook'
}

export function shouldRenderGoogleIcon(props) {
  return props.type === 'Google'
}

export function shouldRenderAppleIcon(props) {
  return props.type === 'Apple'
}

export function shouldNotRenderButton(props, isAppleSsoEnabled) {
  return shouldRenderAppleIcon(props) && !isAppleSsoEnabled
}
